module.exports = __webpack_public_path__ + "media/29543__bennychico11__wink.7a89a361.mp4";